import { useQuery } from "@tanstack/react-query";
import axios from "const/axios";
import { API_URL } from "const/constants";
import { modulePaymentsQueryKey } from "./moduleFinanceQueries";

export const MODULE_PAYMENT_PATHS = {
  VISA: "visa-applications",
  INSURANCE: "insurance",
  RPL_CLIENT: "rpl",
  SKILL_ASSESSMENT: "skill-assessment",
};

const paymentsUrl = (moduleType, moduleId) =>
  `${API_URL}/${MODULE_PAYMENT_PATHS[moduleType]}/${moduleId}/payments`;

export const useModulePayments = (moduleType, moduleId) =>
  useQuery({
    queryKey: modulePaymentsQueryKey(moduleType, moduleId),
    queryFn: () => axios.get(paymentsUrl(moduleType, moduleId)).then((r) => r.data?.data ?? []),
    enabled: Boolean(moduleId) && Boolean(MODULE_PAYMENT_PATHS[moduleType]),
    refetchOnMount: true,
    refetchOnWindowFocus: false,
  });

export const addModulePayment = (moduleType, moduleId, payload) =>
  axios.post(paymentsUrl(moduleType, moduleId), payload);

export const resubmitModulePayment = (moduleType, moduleId, paymentId, payload) =>
  axios.post(`${paymentsUrl(moduleType, moduleId)}/${paymentId}/resubmit`, payload ?? undefined);
